<template>
  <div class="home-container">
    <section class="intro">
      <div class="hero-content">
        <h1>{{ $t('homepage_title') }}</h1>
        <h2>{{ $t('homepage_subtitle') }}</h2>
        <p>{{ $t('homepage_description') }}</p>
        <router-link to="/toolspage">
            <button class="cta-button">{{ $t('homepage_button') }}</button>
        </router-link>
      </div>
    </section>

    <section class="intro-info">
      <div class="content-wrapper">
        <h2>{{ $t('homepage_blue_title') }}</h2>
        <p>{{ $t('homepage_blue_description') }}</p>
      </div>
    </section>

    <section class="main" id="pae-como-fundamento">
      <div class="content-wrapper">
        <h2>{{ $t('content_title') }}</h2>
        <div class="pae-content">
          <div class="two-columns">
            <div>
              <p>{{ $t('content_box1') }}</p>
            </div>
            <div>
              <p>{{ $t('content_box2') }}</p>
            </div>
          </div>
          
          <div class="strategic-lines">
            <h4>{{ $t('strategic-lines1') }}</h4>
            <p>{{ $t('strategic-lines2') }}</p>
            
            <div class="lines-grid">
              <div class="line-card">
                <p>{{ $t('strategic-lines3') }}</p>
              </div>
              <div class="line-card">
                <p>{{ $t('strategic-lines4') }}</p>
              </div>
              <div class="line-card">
                <p>{{ $t('strategic-lines5') }}</p>
              </div>
            </div>
          </div>
          
          <div class="two-columns">
            <div>
              <p>{{ $t('content_box3') }}</p>
            </div>
            <div>
              <p>{{ $t('content_box4') }}</p>
            </div>
          </div>
          <a :href="paeLink">
            <button class="secondary-button">{{ $t('content_button') }}</button>
          </a>
          
        </div>
      </div>
    </section>

    <section class="ref">
      <div class="content-wrapper">
        <div class="ref-content">
          <div class="left">
            <h2>{{ $t('ref_title') }}</h2>
              <p>{{ $t('ref_description') }}</p>
                <a href="https://iwrmactionhub.org/">
                <button class="tertiary-button">{{ $t('ref_button') }}</button>
                </a>
          </div>
          <div class="right">
            <img :src="iwrmToolboxImage" alt="IWRM Toolbox Platform Screenshot">
          </div>
        </div>
      </div>
    </section>

    <section class="tutorial">
      <div class="content-wrapper">
        <div class="tutorial-content">
          <div class="tutorial-video">
            <iframe
              :src="`https://www.youtube.com/embed/${iwrmTutorialVideoId}`"
              title="IWRM Toolbox Tutorial"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <div class="tutorial-text">
            <h2>{{ $t('tutorial_title') }}</h2>
            <p>{{ $t('tutorial_description') }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import script from "./script.js";

export default script;
</script>

<style scoped src="./style.css"></style>